module.exports = __webpack_public_path__ + "img/tuanjian2.d2f1131e.png";